import { render, staticRenderFns } from "./Inscription-new.vue?vue&type=template&id=5709974f&scoped=true&"
import script from "./Inscription-new.vue?vue&type=script&lang=js&"
export * from "./Inscription-new.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-new.vue?vue&type=style&index=0&id=5709974f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709974f",
  null
  
)

export default component.exports